import CalculationsChannelController from "./calculations/controller";

(function () {
  const calculationsStatusApp = function () {
    const controller = new CalculationsChannelController();
    controller.start();
  };

  if (typeof window !== "undefined") {
    window.calculationsStatusApp = calculationsStatusApp;
  }

  return calculationsStatusApp();
})();
